import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

const Content = ({ children }: React.PropsWithChildren) => {
  return (
      <Box alignItems="center" justifyContent="center">
        <Box gap="s16" width="full">
          {children}
        </Box>
      </Box>
  )
}

export default Content
